(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-top-win.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-top-win.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  selectedResultAtom,
  correctionStepAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  ResultDrawLocationName
} = svs.lyckoplatsen.components.shared_result.react.components;
const formatCurrency = svs.utils.format.Currency;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const formatTime = svs.utils.date.FormatTime;
const ResultDrawTopWin = _ref => {
  let {
    className
  } = _ref;
  const result = useAtomValue(selectedResultAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const isCorrectionFirstStepPrimary = productMapping.isLyckoplatsenPrimary(result.productId) && correctionStep === 1;
  const topwin = (isCorrectionFirstStepPrimary ? result.distributionDrawItems[0] : result.distribution[0]).amountSek.slice(0, -3);
  const header = isCorrectionFirstStepPrimary ? 'Chans till toppvinst på' : 'Toppvinst';
  return React.createElement("div", {
    className: "lp-draw-top-win-container ".concat(className)
  }, React.createElement("div", {
    className: "container-body"
  }, React.createElement("div", {
    className: "lp-draw-top-win"
  }, React.createElement("span", {
    className: "text"
  }, header), React.createElement("span", {
    className: "date"
  }, formatTime('eeee d/M', result.regCloseTime)), React.createElement("span", {
    className: "amount"
  }, formatCurrency(topwin), " kr"), React.createElement(ResultDrawLocationName, {
    isChild: true
  }))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDrawTopWin
});

 })(window);